import api from "@/config/axiosConfig";
import { AxiosResponse } from "axios";
import { ItineraryItem } from "@/types/trip";

class ExperienceService {
  async createCustomActivity(
    activity: ItineraryItem,
    location: {
      waytora_id: string;
      city: string;
      country: string;
    },
    addToLibrary: boolean
  ): Promise<AxiosResponse> {
    return await api.experiences.post("/custom-activity", {
      activity,
      location,
      addToLibrary,
    });
  }

  // generate experiences
  async generateExperiences(
    experience: string,
    locationId: string
  ): Promise<AxiosResponse> {
    return await api.experiences.get("/general", {
      params: {
        name: experience,
        location_id: locationId,
        generate: true,
      },
    });
  }

  // custom place search
  async searchCustomPlaces(
    query: string,
    latitude: number,
    longitude: number
  ): Promise<
    AxiosResponse<{
      results: Array<{
        name: string;
        address: string;
        coordinates: {
          latitude: number;
          longitude: number;
        };
        id: string;
      }>;
    }>
  > {
    return await api.places.get("/autocomplete/custom", {
      params: { q: query, lat: latitude, lng: longitude },
    });
  }

  async uploadCustomActivityImages(
    images: File[]
  ): Promise<AxiosResponse<{ urls: string[] }>> {
    const formData = new FormData();
    images.forEach((file, index) => {
      formData.append(`images[${index}]`, file);
    });

    return await api.experiences.post("/custom/images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export const experienceService = new ExperienceService();
export default experienceService;
